import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { DisqusModule } from 'ngx-disqus';

import { BlogRoutingModule } from './blog-routing.module';
import { AllArticlesPageComponent } from './all-articles-page/all-articles-page.component';
import { ArticlePageComponent } from './article-page/article-page.component';
import { ContributorListPageComponent } from './contributor-list-page/contributor-list-page.component';
import { ContributorPageComponent } from './contributor-page/contributor-page.component';
import { SportArticlesPageComponent } from './sport-articles-page/sport-articles-page.component';
import { FindComponent } from './find/find.component';
import { ArticleListComponent } from './article-list/article-list.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { GeneralModule } from '../general/general.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { ArticleBodyComponent } from './article-body/article-body.component';
import { InContentBlockShellComponent } from './in-content-block-shell/in-content-block-shell.component';
import { PreMatchPredictionsBlockComponent } from './pre-match-predictions-block/pre-match-predictions-block.component';
import { MatchCentreModule } from '../match-centre/match-centre.module';
import { MatchPageHeaderBlockComponent } from './match-page-header-block/match-page-header-block.component';
import { MatchBestBetBlockComponent } from './match-best-bet-block/match-best-bet-block.component';
import { BookPipesModule } from '../book-pipes/book-pipes.module';
import { BettingActionBannerComponent } from './betting-action-banner/betting-action-banner.component';
import { ContentBannerComponent } from './content-banner/content-banner.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { BreadcrumbComponent, BreadcrumbItemDirective } from "xng-breadcrumb";
import { SubscribePromptComponent } from './subscribe-prompt/subscribe-prompt.component';
import { AiPromptComponent } from './ai-prompt/ai-prompt.component';
import { OddsDisclaimerComponent } from '../general/odds-disclaimer/odds-disclaimer.component';


@NgModule({

	declarations: [
	AllArticlesPageComponent,
	ArticlePageComponent,
	ContributorListPageComponent,
	ContributorPageComponent,
	SportArticlesPageComponent,
	FindComponent,
	ArticleListComponent,
	ArticleBodyComponent,
	InContentBlockShellComponent,
	PreMatchPredictionsBlockComponent,
	MatchPageHeaderBlockComponent,
	MatchBestBetBlockComponent,
	BettingActionBannerComponent,
	ContentBannerComponent,
	SubscribePromptComponent,
	AiPromptComponent,
	],
	imports: [
	CommonModule,
	BlogRoutingModule,
	FormsModule,
	FontAwesomeModule,
	RouterModule,
	SidebarModule,
	GeneralModule,
	MatchCentreModule,
	BookPipesModule,
	NgxPaginationModule,
	BreadcrumbComponent,
	BreadcrumbItemDirective,
	OddsDisclaimerComponent,
	// DisqusModule,
	],
	exports: [
		ArticleBodyComponent,
	]
})

export class BlogModule { }
